import { Snackbar, Alert } from "@mui/material";

export function SnackDialog({
  open,
  onClose,
  message,
  severity = "success",
  autoHideDuration = 3000,
  anchorOrigin = { vertical: "bottom", horizontal: "center" },
  filled = true,
  action,
}) {
  return (
    <Snackbar
      open={open}
      autoHideDuration={autoHideDuration ?? undefined}
      onClose={onClose}
      anchorOrigin={anchorOrigin}
    >
      <Alert
        onClose={onClose}
        severity={severity}
        action={action}
      >
        {message}
      </Alert>
    </Snackbar>
  );
}
